import React, { useRef } from 'react';
import { useFocusRing } from '@react-aria/focus';
import { useCheckbox } from '@react-aria/checkbox';
import { useToggleState } from '@react-stately/toggle';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import uuid from 'uuid/v4';
import classNames from 'classnames';
import PropTypes from 'prop-types';


const Checkbox = function CheckboxComponent(props) {
  const {
    className, describedBy, focusRingClass, labelledBy, children, required, labelRef,
  } = props;

  const labelId = useRef(uuid());
  const state = useToggleState(props);
  const ref = useRef();
  const { inputProps } = useCheckbox(props, state, ref);
  const { isFocusVisible, focusProps } = useFocusRing();

  const focusClass = focusRingClass || 'checkbox__focus-ring';
  const labelProps = {
    className: classNames(className, { 'checkbox__label--checked': state.isSelected, [focusClass]: isFocusVisible }),
    ref: labelRef,
  };
  const iconClassNames = classNames('checkbox__icon', { 'checkbox__icon--checked': state.isSelected });

  inputProps['aria-labelledby'] = classNames(labelId.current, labelledBy);
  inputProps['aria-describedby'] = describedBy;
  inputProps['aria-checked'] = null;

  return (
    <label {...labelProps}>
      <VisuallyHidden elementType="span">
        <input {...inputProps} {...focusProps} ref={ref} required={required} />
      </VisuallyHidden>
      <span className={iconClassNames} />
      <div id={labelId.current} className="checkbox__label">{children}</div>
    </label>
  );
};

Checkbox.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  describedBy: PropTypes.string,
  focusRingClass: PropTypes.string,
  labelledBy: PropTypes.string,
  required: PropTypes.bool,
  labelRef: PropTypes.shape({}),
};

Checkbox.defaultProps = {
  describedBy: '',
  labelledBy: '',
  focusRingClass: '',
  required: false,
  labelRef: null,
};

export default Checkbox;
